import { Database, FlaskConical } from "lucide-react";

export default function SourceBadge({ source, note, liveLabel }) {
    const mock = source === "mock";
    return (
        <div
            className={`flex items-center gap-2 px-3 py-1.5 rounded-sm border ${
                mock ? "bg-[#f59e0b]/10 border-[#f59e0b]/40" : "bg-[#22C55E]/5 border-[#22C55E]/30"
            }`}
            title={note || ""}
            data-testid="source-badge"
        >
            {mock ? <FlaskConical size={12} className="text-[#f59e0b]" /> : <Database size={12} className="text-[#22C55E]" />}
            <span className={`font-mono-data text-[10px] uppercase tracking-widest ${mock ? "text-[#fde68a]" : "text-[#86efac]"}`}>
                {mock ? "Mock data" : liveLabel || "Live"}
            </span>
            {mock && note && (
                <span className="hidden lg:inline font-mono-data text-[10px] text-[#A1A1AA] normal-case tracking-normal" data-testid="source-note">
                    · {note}
                </span>
            )}
        </div>
    );
}
